import {SvgIconType} from 'common/components/svg-icon';
import {MetricType} from 'common/types/reports/bookmark';

export type ValidMetricTypes =
  | MetricType.Cohort
  | MetricType.People
  | MetricType.Simple
  | MetricType.Funnel
  | MetricType.Retention
  | MetricType.RetentionFrequency
  | MetricType.Formula;

export const MetricTypeIcons: {[key in ValidMetricTypes]: SvgIconType} = {
  [MetricType.Simple]: `behavior-simple`,
  [MetricType.Funnel]: `behavior-funnel`,
  [MetricType.Retention]: `behavior-retention`,
  [MetricType.RetentionFrequency]: `behavior-retention`,
  [MetricType.People]: `group-attribute`,
  [MetricType.Cohort]: `brand-cohorts`,
  [MetricType.Formula]: `behavior-simple`,
};

// Icons before first_class_metrics feature flag
export const OldMetricTypeIcons: {[key in ValidMetricTypes]: SvgIconType} = {
  [MetricType.Simple]: `brand-insights`,
  [MetricType.Funnel]: `brand-funnels`,
  [MetricType.Retention]: `brand-retention`,
  [MetricType.RetentionFrequency]: `brand-retention`,
  [MetricType.People]: `profile`, // TODO
  [MetricType.Cohort]: `users`, // TODO
  [MetricType.Formula]: `behavior-simple`, // TODO
};
